import { parseISO } from "date-fns";
import { getTimezoneOffset } from "date-fns-tz";

export const shouldForceDraftStatus = (
  scheduledStartAt: string | undefined,
): boolean => {
  if (!scheduledStartAt) return false;

  const [datePart, timePart, timezone = "UTC"] = scheduledStartAt.split(" ");

  const isoString = `${datePart}T${timePart}`;

  const localDate = parseISO(isoString);

  const tzOffset = getTimezoneOffset(timezone, localDate);

  const scheduledDate = new Date(localDate.getTime() - tzOffset);

  const now = new Date();
  return scheduledDate > now;
};
